import { convertStructToJson, convertJsonToStruct } from 'ricos-content/libs/struct-converters';
import { Node_Type } from 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const isDraftEntityConfig = (data) => (data.width || data.alignment || data.textWrap) && (["content", "original", "fullWidth", "small"].includes(data.size) || ["center", "left", "right"].includes(data.alignment));
const toContainerData = (data) => __spreadValues(__spreadValues(__spreadValues({}, typeof data.size === "string" ? { width: { size: data.size.toUpperCase() } } : {}), typeof data.alignment === "string" ? { alignment: data.alignment.toUpperCase() } : {}), typeof data.textWrap !== "undefined" ? { textWrap: data.textWrap !== "nowrap" } : {});
const fromContainerData = (data) => {
  var _a;
  return __spreadProps(__spreadValues(__spreadValues({}, ((_a = data.width) == null ? void 0 : _a.size) ? { size: data.width.size.toLowerCase() } : {}), data.alignment ? { alignment: data.alignment.toLowerCase() } : {}), {
    textWrap: data.textWrap ? "wrap" : "nowrap"
  });
};
const getContainerData = (externalData) => {
  if (isDraftEntityConfig(externalData.config || {})) {
    return toContainerData(externalData.config);
  }
};
const externalConverter = {
  toTiptap: {
    types: [Node_Type.EXTERNAL],
    convert: (node) => {
      const data = convertStructToJson(node.externalData);
      const containerData = getContainerData(data);
      return {
        type: Node_Type.EXTERNAL,
        attrs: __spreadValues(__spreadProps(__spreadValues({}, data), {
          id: node.id
        }), containerData ? { containerData } : {})
      };
    }
  },
  fromTiptap: {
    types: [Node_Type.EXTERNAL],
    convert: (node) => {
      const _a = node.attrs || {}, { id, containerData } = _a, data = __objRest(_a, ["id", "containerData"]);
      if (containerData && isDraftEntityConfig(data.config || {})) {
        data.config = fromContainerData(containerData);
      }
      return __spreadValues({
        type: Node_Type.EXTERNAL,
        id,
        nodes: [],
        externalData: convertJsonToStruct(data)
      }, containerData && !isDraftEntityConfig(data.config || {}) ? { containerData } : {});
    }
  }
};

export { externalConverter };
//# sourceMappingURL=external-converter.js.map
